
import state from './state';
import Store from '../base';


export default class Exports extends Store {
    constructor(model, ng){

        state.model = model;

        super({state, ng});
    }
}



// WEBPACK FOOTER //
// ./src/app/store/exports/index.js